import React from 'react';

export interface TabPaneProps extends React.PropsWithChildren<any> {
  key: string;
  text: string;
}

const TabPane = ({ children }: TabPaneProps) => {
  return (
    <div className="tab-pane">
      {children}
    </div>
  );
}

export default TabPane as React.FC<TabPaneProps>;
